(function (module) {
  'use strict';
  module
    .controller('singleSignOnController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService',
      'singleSignOn', 'ngDialog', '$q',
      function ($scope, progressBar, clientSelectService, agencySelectService, singleSignOn,
        ngDialog, $q) {
        const progress = progressBar.getProgressBar();
        $scope.singleSignOn = {};
        $scope.validate = {};

        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function getSingleSignOnByOrganizationId() {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            progress.start();
            singleSignOn.getSingleSignOnByOrganizationId(clientSelectService.getSelectedClient()
              .id).then(function (response) {
                $scope.isEdit = true;
                $scope.singleSignOn = response.data;
              }, function (err) {
                $scope.isEdit = false;
                $scope.singleSignOn = {};                
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>Single sign on not found</p>`;                     
                    $scope.errTitle = 'Single Sign On Error';
                  },],
                });
              })
              .finally(function () {
                progress.complete();
              });
          } else if (valid.agencyValid) {
            // toastFactory.toast_info('Please select a client.');
          } else {
            // toastFactory.toast_info('Please select an agency and then client.');
          }
        };

        $scope.saveSingleSignOn = function () {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if ($scope.singleSignOn.Cert) {
              const organization = clientSelectService.getSelectedClient();
              progress.start();
              singleSignOn.addSingleSignOn($scope.singleSignOn, organization.id).then(function () {
                const dialogPost = ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Single Sign On Success';
                    $scope.successMsg = 'The single sign on has been saved succesfully.';
                  },],
                });
                dialogPost.closePromise.then(function (data) {
                  $state.go('app.singleSignOn');
                });
              }, function (err) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText} : ${err.data}</p>`;
                    $scope.errTitle = 'Single Sign On Error';
                  },],
                });
              })
                .finally(function () {
                  progress.complete();
                });
            } else {
              if (!$scope.singleSignOn.Cert) {
                $scope.validate.cert = true;
              }

            }
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>"Please select client."</p>`;
                $scope.errTitle = 'Single Sign On Error';
              },],
            });
          }
        };

        $scope.updateSingleSignOn = function () {
          const valid = validateAgencyAndClientSelection();
          if (valid.agencyValid && valid.clientValid) {
            if ($scope.singleSignOn.Cert) {
              progress.start();

              singleSignOn.updateSingleSignOn($scope.singleSignOn.OrganizationId, $scope.singleSignOn).then(function (singleSignOn) {
                ngDialog.open({
                  template: 'templates/partials/viewSuccessMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.strTitle = 'Single Sign On Success';
                    $scope.successMsg = 'The single sign on has been updated succesfully.';
                  },],
                });
              })
                .finally(function () {
                  progress.complete();
                });
            } else {
              if (!$scope.singleSignOn.Cert) {
                $scope.validate.cert = true;
              }
            }
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>"Please select client."</p>`;
                $scope.errTitle = 'Single Sign On Error';
              },],
            });
          }
        };

        getSingleSignOnByOrganizationId();

        // Watch orgFilterService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function () {
          return clientSelectService.getSelectedClient();
        }, function (newValue, oldValue) {

          if (newValue !== oldValue) {
            getSingleSignOnByOrganizationId();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/singleSignOnController.js